module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offline"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            Whoops!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("\n            You've lost the connection to the internet.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n            We could not register a live connection to the internet. Since this application uses network functions, please make sure you have a valid network connection and try again.\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87b029dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/offline.vue
// module id = 293
// module chunks = 1